import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import ActionTypes from '../../../constants/ActionTypes';
import { utils as tileGridUtils } from '@gisatcz/ptr-tile-grid';
import { isEmpty as _isEmpty, reduce as _reduce } from 'lodash';
var actionTypes = ActionTypes.DATA.ATTRIBUTE_DATA; // ============ creators ===========

/**
 * It ensure adding index and adding or updating received attribute data from BE under given spatial index.
 * Add data to state only when attributeData received, in case of empty attributeData it adds only index.
 * @param {Object} attributeData Object received from BE contains under attributeDataKey object of data attributes [id]: [value].
 * @param {Object} spatialIndexData Spatial index related to the data.
 * @param {Object} attributeDataFilter Filler object contains modifiers, layerTemplateKey or areaTreeLevelKey, styleKey, and optional values for attributeFilter, dataSourceKeys and featureKeys.
 * @param {Array?} order
 * @param {string?} changedOn
 */

var receiveIndexedWithSpatialIndex = function receiveIndexedWithSpatialIndex(attributeData, spatialIndexData, attributeDataFilter, order, changedOn) {
  return function (dispatch) {
    if (!_isEmpty(attributeData)) {
      dispatch(addDataAndIndexBasedOnSpatialData(attributeDataFilter, order, attributeData, spatialIndexData, changedOn));
    } else {
      // add to index
      dispatch(createAndAddIndexBasedOnSpatialData(attributeDataFilter, order, spatialIndexData, changedOn));
    }
  };
};
/**
 * Ensure adding index and adding or updating received attribute data from BE.
 * @param {Object} attributeData
 * @param {Array} attributeData.index
 * @param {Object} attributeData.attributeData
 * @param {Object} attributeDataFilter Filler object contains modifiers, layerTemplateKey or areaTreeLevelKey, styleKey, and optional values for attributeFilter, dataSourceKeys and featureKeys.
 * @param {Array?} order
 * @param {Array?} start
 * @param {Array?} total
 * @param {string?} changedOn
 * @param {Number?} limit Limitation for loading attributeData
 */


var receiveIndexed = function receiveIndexed(attributeData, attributeDataFilter, order, start, total, changedOn, limit) {
  return actionAddDataAndIndex(attributeDataFilter, order, total, start, attributeData.index, attributeData.attributeData, changedOn, limit);
};
/**
 * Add data and index at the same time
 *
 * @param {Object} attributeDataFilter Filler object contains modifiers, layerTemplateKey or areaTreeLevelKey, styleKey, and optional values for attributeFilter, dataSourceKeys and featureKeys.
 * @param {Object} attributeData Object received from BE contains under attributeDataKey object of data attributes [id]: [value].
 * @param {Object} spatialIndexData Spatial index related to the data.
 * @param order {Array}
 * @param changedOn {string}
 */


function addDataAndIndexBasedOnSpatialData(attributeDataFilter, order, attributeData, spatialIndexData, changedOn) {
  return function (dispatch) {
    for (var _i = 0, _Object$keys = Object.keys(attributeData); _i < _Object$keys.length; _i++) {
      var attributeDataSourceKey = _Object$keys[_i];
      dispatch(actionAddDataAndIndexBasedOnSpatialData(attributeDataSourceKey, attributeData[attributeDataSourceKey], attributeDataFilter, order, [spatialIndexData], changedOn));
    }
  };
}
/**
 * Create and add index for given attribute data based on related spatial data index.
 * @param {Object} attributeDataFilter Filler object contains modifiers, layerTemplateKey or areaTreeLevelKey, styleKey, and optional values for attributeFilter, dataSourceKeys and featureKeys.
 * @param {Array?} order
 * @param {Object} spatialIndexData Spatial index related to the data.
 * @param {*} changedOn
 */


function createAndAddIndexBasedOnSpatialData(attributeDataFilter, order, spatialIndexData, changedOn) {
  return actionAddIndexWithSpatialIndex(attributeDataFilter, order, [spatialIndexData], changedOn);
}
/**
 * Create new index based on given level and tiles with loading indicator.
 * @param {Object} attributeDataFilter Filler object contains modifiers, layerTemplateKey or areaTreeLevelKey, styleKey, and optional values for attributeFilter, dataSourceKeys and featureKeys.
 * @param {Array?} order
 * @param {Number} level
 * @param {Array.[Array]} tiles
 */


function addLoadingSpatialIndex(attributeDataFilter, order, level, tiles) {
  var changedOn = null; //create index with tiles value "true" that indicates loading state

  var loadingTiles = _reduce(tiles, function (acc, tile) {
    var tileId = tileGridUtils.tileAsString(tile);
    acc[tileId] = true;
    return acc;
  }, {});

  var index = _defineProperty({}, level, loadingTiles);

  return actionAddIndexWithSpatialIndex(attributeDataFilter, order, [index], changedOn);
}
/**
 * Create new index based on pagination with loading indicator.
 * @param {Object} pagination
 * @param {Number} pagination.limit Limitation for loading attributeData
 * @param {Number} pagination.offset
 * @param {Object} attributeDataFilter Filler object contains modifiers, layerTemplateKey or areaTreeLevelKey, styleKey, and optional values for attributeFilter, dataSourceKeys and featureKeys.
 * @param {Array?} order
 */


function addLoadingIndex(pagination, attributeDataFilter, order) {
  var changedOn = null; // Fake new data object for common action of size same like pagination.limit
  // Action "common.addIndex" needs array of data objects with key to create new index.
  // "data" is a Array of the minimal data for construct index in common actoin.
  // Use key = true as a loading identificator

  var data = new Array(pagination.limit).fill({
    key: true
  }); // filter, order, data, start, count, changedOn

  return actionAddIndex(attributeDataFilter, order, data, pagination.offset + 1, null, changedOn);
} // ============ helpers ============

/**
 * Get data for indexing for vectorTiled spatial data
 * @param {Object} spatialData
 * @param {Object} attributeData
 * @return {Object}
 */


function getTiledIndexDataBySpatialData(spatialData, attributeData) {
  var indexByLevelByTileByDataSourceKey = {}; //Attribute data indexes are stored in related spatial index
  //for all spatial data keys in spatialData

  for (var _i2 = 0, _Object$entries = Object.entries(spatialData); _i2 < _Object$entries.length; _i2++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i2], 2),
        datasource = _Object$entries$_i[1];

    //for all levels in spatial data source
    for (var _i3 = 0, _Object$entries2 = Object.entries(datasource.spatialIndex); _i3 < _Object$entries2.length; _i3++) {
      var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i3], 2),
          level = _Object$entries2$_i[0],
          tiles = _Object$entries2$_i[1];

      if (!indexByLevelByTileByDataSourceKey[level]) {
        indexByLevelByTileByDataSourceKey[level] = {};
      } //for all tiles in tiles


      for (var _i4 = 0, _Object$entries3 = Object.entries(tiles); _i4 < _Object$entries3.length; _i4++) {
        var _Object$entries3$_i = _slicedToArray(_Object$entries3[_i4], 2),
            tile = _Object$entries3$_i[0],
            tileData = _Object$entries3$_i[1];

        // If empty attributeData, then rewrite "loading" state.
        // or
        // Prepare empty tile for new data if tile does not exists.
        if (!indexByLevelByTileByDataSourceKey[level][tileGridUtils.tileAsString(tile)] || _isEmpty(attributeData)) {
          indexByLevelByTileByDataSourceKey[level][tileGridUtils.tileAsString(tile)] = {};
        }

        if (!_isEmpty(attributeData)) {
          var _loop = function _loop() {
            var _indexByLevelByTileBy, _indexByLevelByTileBy2;

            var _Object$entries4$_i = _slicedToArray(_Object$entries4[_i5], 2),
                attributeDataSourceKey = _Object$entries4$_i[0],
                attributeDataSource = _Object$entries4$_i[1];

            // Save only tileData that are incuded in attribute data keys
            var indexes = tileData.filter(function (e) {
              return Object.keys(attributeDataSource).includes(e.toString());
            }); //Add to existing index

            if (indexByLevelByTileByDataSourceKey !== null && indexByLevelByTileByDataSourceKey !== void 0 && (_indexByLevelByTileBy = indexByLevelByTileByDataSourceKey[level]) !== null && _indexByLevelByTileBy !== void 0 && (_indexByLevelByTileBy2 = _indexByLevelByTileBy[tileGridUtils.tileAsString(tile)]) !== null && _indexByLevelByTileBy2 !== void 0 && _indexByLevelByTileBy2[attributeDataSourceKey]) {
              indexByLevelByTileByDataSourceKey[level][tileGridUtils.tileAsString(tile)][attributeDataSourceKey] = [].concat(_toConsumableArray(indexByLevelByTileByDataSourceKey[level][tileGridUtils.tileAsString(tile)][attributeDataSourceKey]), _toConsumableArray(indexes));
            } else {
              //Create new tile and insert dsKey index data
              indexByLevelByTileByDataSourceKey[level][tileGridUtils.tileAsString(tile)][attributeDataSourceKey] = indexes;
            }
          };

          //for all attribute data source keys in attributeData
          for (var _i5 = 0, _Object$entries4 = Object.entries(attributeData); _i5 < _Object$entries4.length; _i5++) {
            _loop();
          }
        }
      }
    }
  }

  return indexByLevelByTileByDataSourceKey;
}
/**
 * Get data for indexing for vector spatial data
 * @param {Object} attributeData
 * @return {Object}
 */


function getIndexData(attributeData) {
  var indexByDataSourceKey = {};

  for (var _i6 = 0, _Object$entries5 = Object.entries(attributeData); _i6 < _Object$entries5.length; _i6++) {
    var _Object$entries5$_i = _slicedToArray(_Object$entries5[_i6], 2),
        dsKey = _Object$entries5$_i[0],
        data = _Object$entries5$_i[1];

    indexByDataSourceKey[dsKey] = _toConsumableArray(Object.keys(data));
  }

  return indexByDataSourceKey;
} // ============ actions ============


function actionRemoveSpatialIndex(filter, order) {
  return {
    type: actionTypes.SPATIAL_INDEX.REMOVE,
    filter: filter,
    order: order
  };
}
/**
 * @param {Object} attributeDataFilter Filler object contains modifiers, layerTemplateKey or areaTreeLevelKey, styleKey, and optional values for attributeFilter, dataSourceKeys and featureKeys.
 * @param {Array?} order
 * @param {Number} total
 * @param {Number} start
 * @param {Array} index
 * @param {Object} data
 * @param {string?} changedOn
 */


function actionAddDataAndIndexBasedOnSpatialData(attributeDataSourceKey, data, attributeDataFilter, order, indexData, changedOn) {
  return {
    type: actionTypes.ADD_WITH_SPATIAL_INDEX,
    attributeDataSourceKey: attributeDataSourceKey,
    data: data,
    filter: attributeDataFilter,
    order: order,
    indexData: indexData,
    changedOn: changedOn
  };
}
/**
 * @param {Object} attributeDataFilter Filler object contains modifiers, layerTemplateKey or areaTreeLevelKey, styleKey, and optional values for attributeFilter, dataSourceKeys and featureKeys.
 * @param {Array?} order
 * @param {Number} total For how many features data relates.
 * @param {Number} start
 * @param {Array} index
 * @param {Object} data
 * @param {string?} changedOn
 * @param {Number?} limit Limitation for loading attributeData
 */


function actionAddDataAndIndex(attributeDataFilter, order, total, start, index, data, changedOn, limit) {
  return _objectSpread({
    type: actionTypes.ADD_WITH_INDEX,
    filter: attributeDataFilter,
    order: order,
    total: total,
    start: start,
    index: index,
    data: data,
    changedOn: changedOn
  }, limit && {
    limit: limit
  });
}

function actionAddIndexWithSpatialIndex(attributeDataFilter, order, index, changedOn) {
  return {
    type: actionTypes.SPATIAL_INDEX.ADD,
    filter: attributeDataFilter,
    order: order,
    indexData: index,
    changedOn: changedOn
  };
}
/**
 *
 * @param {Object} attributeDataFilter Filler object contains modifiers, layerTemplateKey or areaTreeLevelKey, styleKey, and optional values for attributeFilter, dataSourceKeys and featureKeys.
 * @param {Array?} order
 * @param {Array} data
 * @param {Array?} start
 * @param {Number?} count
 * @param {string?} changedOn
 * @param {Number?} limit Limitation for loading attributeData
 * @returns
 */


function actionAddIndex(attributeDataFilter, order, data, start, count, changedOn, limit) {
  return _objectSpread({
    type: actionTypes.INDEX.ADD,
    filter: attributeDataFilter,
    order: order,
    data: data,
    start: start,
    count: count,
    changedOn: changedOn
  }, limit && {
    limit: limit
  });
}

function actionUpdateStore(data) {
  return {
    type: actionTypes.UPDATE_STORE,
    data: data
  };
} // ============ export ===========


export default {
  addLoadingIndex: addLoadingIndex,
  addLoadingSpatialIndex: addLoadingSpatialIndex,
  getTiledIndexDataBySpatialData: getTiledIndexDataBySpatialData,
  getIndexData: getIndexData,
  receiveIndexedWithSpatialIndex: receiveIndexedWithSpatialIndex,
  receiveIndexed: receiveIndexed,
  removeSpatialIndex: actionRemoveSpatialIndex,
  updateStore: actionUpdateStore //do we use it?

};